import { processAgeDistributionData } from "../utils/dataProcessors";

import { useDemographicsData } from "./useDemographicsData";

export const useDemographicsAgeDistributionData = () => {
    return useDemographicsData({
        select: (data) => processAgeDistributionData(data?.AgeRatios),
    });
};
